/**
 * Channel meta (icons + colors) for rendering social channels.
 */
import { Facebook, Instagram, Linkedin, Music2, Youtube, Twitter } from "lucide-react";

export const CHANNELS = [
    {
        type: "facebook",
        name: "Facebook",
        icon: Facebook,
        color: "#1877F2",
        bg: "bg-[#1877F2]",
    },
    {
        type: "instagram",
        name: "Instagram",
        icon: Instagram,
        color: "#E4405F",
        bg: "bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF]",
    },
    {
        type: "linkedin",
        name: "LinkedIn",
        icon: Linkedin,
        color: "#0A66C2",
        bg: "bg-[#0A66C2]",
    },
    {
        type: "tiktok",
        name: "TikTok",
        icon: Music2,
        color: "#FE2C55",
        bg: "bg-[#0F0F0F]",
    },
    {
        type: "youtube",
        name: "YouTube",
        icon: Youtube,
        color: "#FF0000",
        bg: "bg-[#FF0000]",
    },
    {
        type: "x",
        name: "X (Twitter)",
        icon: Twitter,
        color: "#0F1419",
        bg: "bg-[#0F0F0F]",
    },
];

export const channelByType = (type) => CHANNELS.find((c) => c.type === type);
